/**
 * Stable per-browser device identifier + metadata for the trusted-device
 * login flow. The id is generated once and kept in localStorage so the same
 * browser is recognised on later logins; a login from an unknown id triggers
 * an email OTP challenge (see backend AuthController::login).
 */

const STORAGE_KEY = 'mmf_device_id'

function uuid() {
	try {
		if (typeof crypto !== 'undefined' && crypto.randomUUID) {
			return crypto.randomUUID()
		}
	} catch (e) {
		/* fall through */
	}
	// RFC4122-ish fallback
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0
		const v = c === 'x' ? r : (r & 0x3) | 0x8
		return v.toString(16)
	})
}

export function getDeviceId() {
	try {
		let id = localStorage.getItem(STORAGE_KEY)
		if (!id) {
			id = uuid()
			localStorage.setItem(STORAGE_KEY, id)
		}
		return id
	} catch (e) {
		// Private mode / storage disabled — fall back to a session-only id.
		return uuid()
	}
}

function detectOs() {
	const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || ''
	if (/Windows NT ([\d.]+)/.test(ua)) return { os_type: 'Windows', os_version: RegExp.$1 }
	if (/Mac OS X ([\d_]+)/.test(ua)) return { os_type: 'macOS', os_version: RegExp.$1.replace(/_/g, '.') }
	if (/Android ([\d.]+)/.test(ua)) return { os_type: 'Android', os_version: RegExp.$1 }
	if (/(iPhone|iPad); CPU .*OS ([\d_]+)/.test(ua)) return { os_type: 'iOS', os_version: RegExp.$2.replace(/_/g, '.') }
	if (/Linux/.test(ua)) return { os_type: 'Linux', os_version: '' }
	return { os_type: 'unknown', os_version: '' }
}

export function getDeviceMeta() {
	return {
		device_id: getDeviceId(),
		device_type: 'web',
		...detectOs(),
	}
}
